import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
@Component({
    selector: 'page-section-element',
    templateUrl: './page-section-element.component.html',
    styleUrls: ['./page-section-element.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class PageSectionElementComponent implements OnInit {

    @Input() title: string = '';
    @Input() paragraph: string = '';
    @Input() anchor: string = '';
    @Input() image: string = '';		 // webp
    @Input() fallbackImage: string = ''; // jpg, jpeg, png
    @Input() alt: string = '';
    @Input() icon: string = '';
    @Input() expansionEnabled: boolean = false;
    @Input() buttonText: string = '';
    @Input() topIcon: boolean = false;

    @Output() buttonClicked = new EventEmitter<void>();
    @Output() anchorClicked = new EventEmitter<void>();

    public expand: boolean = false;

    constructor(private router: Router) { }

    public toggleExpand() {
        this.expand = !this.expand;
    }

    public buttonClick() {
        this.buttonClicked.emit();
    }

    public anchorClick() {
        this.anchorClicked.emit();
    }

    ngOnInit(): void {
    }

}
